import { render, staticRenderFns } from "./DspForm.vue?vue&type=template&id=4faa7c42&lang=pug"
import script from "./DspForm.vue?vue&type=script&lang=js"
export * from "./DspForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports